<template>
  <div class="login">
    <!-- <div class="login-box"> -->
    <!-- <el-form :model="code" wdith="80px">
        <el-form-item label="用戶名">
          <el-input v-model="code" placeholder="username"></el-input>
        </el-form-item>
    </el-form>-->
    <!-- <el-button type="primary" ></el-button> -->
    <!-- <mBtn @click="login">登入</mBtn> -->
    <!-- </div> -->

    <!-- Navigation -->
    <nav
      class="navbar navbar-black navbar-static-top"
      role="navigation"
      style="margin-bottom: 0; color:rgba(0,0,0,0.87);"
    >
      <div class="navbar-header">
        <a class="navbar-brand" href="https://www.gov.mo/zh-hant">
          <img src="../../assets/web/govmo-logo-white.png" />
        </a>
        <a href="/zh-hant/">
          <div class="navbar-text">澳門公共服務一戶通</div>
        </a>
      </div>
    </nav>

    <div id="wrapper" class="valign-wrapper">
      <section id="sign-in" class="valign">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">
              <div class="halign-wrapper">
                <div id="sign-in-card-container">
                  <div class="panel panel-danger" style="text-align:left;">
                    <div class="panel-body">
                      <p class="text-danger">“澳門公共服務一戶通”(簡稱一戶通) 帳戶於2019年1月1日起正式推出，</p>
                      <ul>
                        <li>
                          申請“澳門公共服務一戶通”，請按
                          <a
                            href="https://www.gov.mo/zh-hant/services/ps-1047/"
                          >「如何申請」</a>
                        </li>
                        <li>
                          了解“政府服務登入帳戶”的安排，按
                          <a
                            href="https://www.gov.mo/zh-hant/upgrade-account/"
                          >「關於“政府服務登入帳戶”的安排」</a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div id="sign-in-card" class="card">
                    <div class="card-body">
                      <el-input v-model="user" placeholder="用戶名稱"></el-input>
                      <el-input v-model="password" placeholder="密碼"></el-input>
                      <el-button @click="login">登入</el-button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-1 col-xs-1"></div>
                    <div class="col-lg-5 col-xs-5">
                      <h3>
                        <a
                          style="text-transform: none"
                          href="https://www.gov.mo/zh-hant/services/ps-1047/"
                        >
                          <span>如何申請</span>
                        </a>
                      </h3>
                    </div>
                    <div class="col-lg-5 col-xs-5">
                      <h3>
                        <a href="/zh-hant/help/">需要幫助</a>
                      </h3>
                    </div>
                    <div class="col-lg-1 col-xs-1"></div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12">
                      <h3>
                        <a href="/zh-hant/activate/">啟動帳戶</a>
                      </h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12">
                      <hr />

                      <h3>
                        <a href="https://www.gov.mo/app/">“澳門公共服務一戶通” 手機應用程式</a>
                      </h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12">
                      <h3>
                        <a href="/zh-hant/upgrade/">升級帳戶</a>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div id="footer" class="footer alt-primary-text-color">
      <h2 class="sr-only">Site footer</h2>

      <h3 class="sr-only">Site languages</h3>

      <div class="row">
        <div class="col-xs-12 col-sm-6 col-sm-push-6">
          <div class="footer-nav-language">
            <ul class="footer-nav pull-right">
              <li>
                <a
                  rel="alternate"
                  hreflang="zh-hant"
                  href="/zh-hant/login/?next=%2Fo%2Fauthorize%2F%3Fgrant_type%3Dcode%26client_id%3DnVg7PaIYw9nKF3b1JntLVF8n2wng8DUHX2tqLCT3%26redirect_uri%3Dhttp%3A%2F%2Flocalhost%3A8000%2Flogin%26response_type%3Dcode"
                >繁體中文</a>
              </li>

              <li>
                <a
                  rel="alternate"
                  hreflang="pt"
                  href="/pt/login/?next=%2Fo%2Fauthorize%2F%3Fgrant_type%3Dcode%26client_id%3DnVg7PaIYw9nKF3b1JntLVF8n2wng8DUHX2tqLCT3%26redirect_uri%3Dhttp%3A%2F%2Flocalhost%3A8000%2Flogin%26response_type%3Dcode"
                >Português</a>
              </li>

              <!--<li><a rel="alternate" href="/zh-hant/">繁體中文版</a></li>-->
              <!--<li><a rel="alternate" href="/zh-hans/">簡体中文版</a></li>-->
              <!--<li><a rel="alternate" href="/pt/">Português</a></li>-->
              <!--<li><a rel="alternate" href="/en/">English</a></li>-->
            </ul>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-sm-pull-6">
          <div class="footer-nav-language">
            <ul class="footer-nav pull-left">
              <li>
                <a target="_blank" href="https://www.gov.mo/zh-hant/app/terms-of-use/">使用條款</a>
              </li>
              <li>
                <a target="_blank" href="https://www.gov.mo/zh-hant/app/privacy-policy/">私隱聲明</a>
              </li>

              <li>
                <a target="_blank" href="http://www.safp.gov.mo">協調機構:澳門特別行政區行政公職局</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { basePathUrl } from "../../api/axios";
import mBtn from "../../components/mBtn";
import OAuthAPI from "../../api/OAuthAPI";
import UserCourseAPI from "../../api/UserCourseAPI";
import UserAssessmentsAPI from "../../api/UserAssessmentsAPI";
export default {
  components: { mBtn },
  data() {
    return {
      user: null,
      password: null
    };
  },
  methods: {
    login() {
      // window.location.href =
      //   "http://app.metaarchit.com/elearning/loginOAuthCallback?code=user";
      window.location.href =
        "/elearning/loginOAuthCallback?code=user";
      // OAuthAPI.login(this.user)
      //   .then(res => {
      //     console.log(res);const locale = this.$i18n.locale;
      //     const locale = this.$i18n.locale;
      //     const courseId = sessionStorage.getItem("courseId");
      //     UserCourseAPI.findLastByUserAndCourse(courseId, locale)
      //       .then(res => {
      //         if (res && res.id) {
      //           UserAssessmentsAPI.findByCourse(courseId, locale)
      //             .then(data => {
      //               if (data) {
      //                 this.$router.push("/index");
      //               } else {
      //                 this.$store.commit("changeLast", res);
      //                 this.$router.push({
      //                   path: "/learning/course"
      //                 });
      //               }
      //             })
      //             .catch(err => {
          // this.$error(err);
      //               console.log(err);
      //             });
      //         } else {
      //           this.$router.push("/index");
      //         }
      //       })
      //       .catch(err => {
          // this.$error(err);
      //         console.log(err);
      //       });
      //   })
      //   .catch(err => {
          // this.$error(err);
      //     // alert("登陆失败，请重试");
      //     // console.log(err);
      //     const locale = this.$i18n.locale;
      //     const courseId = sessionStorage.getItem("courseId");
      //     UserCourseAPI.findLastByUserAndCourse(courseId, locale)
      //       .then(res => {
      //         if (res && res.id) {
      //           UserAssessmentsAPI.findByCourse(courseId, locale)
      //             .then(data => {
      //               console.log(data);
      //               if (data) {
      //                 this.$router.push("/index");
      //               } else {
      //                 this.$store.commit("changeLast", res);
      //                 this.$router.push({
      //                   path: "/learning/course"
      //                 });
      //               }
      //             })
      //             .catch(err => {
          // this.$error(err);
      //               console.log(err);
      //             });
      //         } else {
      //           this.$router.push("/index");
      //         }
      //       })
      //       .catch(err => {
          // this.$error(err);
      //         console.log(err);
      //       });
      //   });
      // window.location.href = `${basePathUrl}/oauth/login?code=${this.user}`;
    }
  }
};
</script>

<style lang="scss" scoped>
// .login {
@import "sign/sign-in.css";
@import "sign/sign-in.scss";
@import "sign/bootstrap-theme.min.css";
@import "sign/bootstrap.min.css";
// }
ul {
  margin: 0;
  padding: inherit;
}
#sign-in-card-container a {
  color: #333 !important;
}
.login-box {
  padding: 200px;
  text-align: center;
}
#footer {
  position: fixed;
  width: 100%;
  bottom: 0;
}
.panel-body {
  padding: 15px;
}
/deep/.el-input__inner {
  border: 0px;
  border-bottom: 1px solid rgba(12, 12, 12, 0.12);
  margin-top: 16px;
}
/deep/.el-button {
  color: white;
  background-color: #00796b;
  width: 100%;
  font-size: 17px;
  margin-top: 20px;
}
/deep/.el-button:focus,
.el-button:hover {
  color: white;
  background-color: #00796b;
  border-color: rgba(12, 12, 12, 0.12);
}
/deep/.el-input__inner:focus {
  border-color: #00796b !important;
  border-width: 2px;
  border-radius: 0;
}
@media screen and (max-width: 991px) {
  #footer {
    display: none;
  }
}
</style>